import React from "react";
import PropTypes from "prop-types";
import { AmountFieldsGrid } from "./elements";

export const BettoPaymentAmountLayout = ({ children }) => (
	<AmountFieldsGrid>{children}</AmountFieldsGrid>
);

BettoPaymentAmountLayout.propTypes = {
	children: PropTypes.node,
};
